import { api } from './api';
import { InfoMessage, InfoMessageQuery, InfoMessageAttachment } from '../types';

const API = Object.freeze({
  root: '/info-message',
  byId: '/info-message/{id}',
  isActive: '/info-message/{id}/isActive',
  attachments: '/info-message/{id}/attachments',
  attachmentDelete: '/info-message/{id}/attachments/{attachmentId}/delete',
});

export const getInfoMessages = async (query?: InfoMessageQuery) => {
  const params = new URLSearchParams();
  if (query?.search) params.set('search', query.search);
  if (typeof query?.churchId !== 'undefined') params.set('churchId', String(query.churchId));
  const res = await api.get<InfoMessage[]>(API.root, { params });
  return res.data;
};

export const getInfoMessage = async (id: string) => {
  const res = await api.get<InfoMessage>(API.byId.replace('{id}', id));
  return res.data;
};

export const createInfoMessage = async (payload: Partial<InfoMessage>) => {
  const res = await api.post<InfoMessage>(API.root, payload);
  return res.data;
};

export const updateInfoMessage = async (id: string, payload: Partial<InfoMessage>) => {
  const res = await api.put<InfoMessage>(API.byId.replace('{id}', id), payload);
  return res.data;
};

export const toggleInfoMessageActive = async (id: string, isActive: boolean) => {
  const res = await api.patch<InfoMessage>(API.isActive.replace('{id}', id), { isActive });
  return res.data;
};

export const listInfoMessageAttachments = async (id: string) => {
  const res = await api.get<InfoMessageAttachment[]>(API.attachments.replace('{id}', id));
  return res.data;
};

export const uploadInfoMessageAttachments = async (id: string, files: File[]) => {
  const formData = new FormData();
  files.forEach((f) => formData.append('attachments', f));
  const res = await api.post<InfoMessageAttachment[]>(API.attachments.replace('{id}', id), formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const deleteInfoMessageAttachment = async (id: string, attachmentId: string) => {
  const url = API.attachmentDelete.replace('{id}', id).replace('{attachmentId}', attachmentId);
  const res = await api.patch(url, {});
  return res.data;
};

export const deleteInfoMessage = async (id: string) => {
  // Permanently remove an info-message and its attachments
  return api.delete(API.byId.replace('{id}', id), {});
};
